import { useState } from "react";
import { type PressableProps } from "./types";

export const Pressable = ({
  children,
  onPress,
  style,
  as: Component = "button",
  ...props
}: PressableProps<any>) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false); // Active state

  // Web-specific logic for "pressed" state (onMouseDown/Up)
  const handleMouseDown = () => setIsPressed(true);
  const handleMouseUp = () => setIsPressed(false);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsPressed(false);
  };

  const resolvedChildren =
    typeof children === "function"
      ? children({ pressed: isPressed, hovered: isHovered })
      : children;

  return (
    <Component
      onClick={onPress}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        cursor: "pointer",
        border: "none",
        background: "transparent",
        padding: 0,
        ...(style as React.CSSProperties),
      }}
      {...props}
    >
      {resolvedChildren}
    </Component>
  );
};
